export default "__VITE_ASSET__CcJmSNXS__"